'use strict';

exports.CHANNEL_TYPES = {
    ALEXA: 'alexa',
    API: 'api',
    CAWI: 'cawi',
    FB_MESSENGER: 'fb_messenger',
    WHATSAPP: 'whatsapp',
};

exports.CONTENT_TYPES = {
    DATE: 'date',
    GEO: 'geo',
    LINK: 'link',
    IMAGE: 'image',
    MULTIPLE_CHOICE: 'multipleChoice',
    NUMBER: 'number',
    SINGLE_CHOICE: 'singleChoice',
    SINGLE_CHOICE_BATTERY: 'singleChoiceBattery',
    MULTIPLE_CHOICE_BATTERY: 'multipleChoiceBattery',
    MULTIPLE_NUMBER3_BATTERY: 'multipleNumber3Battery',
    STATIC_IMAGE_GALLERY: 'staticImageGallery',
    STATIC_TEXT: 'staticText',
    STRING: 'string',
    TITLE: 'title',
    RANK: 'rank',
    // Generated variables
    GENERATOR_CLASSIFIER: 'generatorClassifier',
    GENERATOR_ENTITY_EXTRACTION: 'generatorEntityExtraction',
    GENERATOR_FILE_UPLOAD: 'generatorFileUpload',
    GENERATOR_NPS: 'generatorNPS',
    GENERATOR_SENTIMENT_ANALYSIS: 'generatorSentimentAnalysis',
    GENERATOR_CLASSIFIER_2: 'generatorClassifier2',
};

exports.PARSER_ERRORS = {
    REQUIRED: 'REQUIRED_ERROR',
    NOT_NUMBER: 'NOT_NUMBER_ERROR',
    MIN_NUMBER: 'MIN_NUMBER_ERROR',
    MAX_NUMBER: 'MAX_NUMBER_ERROR',
    STEP_NUMBER: 'STEP_NUMBER_ERROR',
    NOT_STRING: 'NOT_STRING_ERROR',
    NOT_DATE: 'NOT_DATE_ERROR',
    MIN_DATE: 'MIN_DATE_ERROR',
    MAX_DATE: 'MAX_DATE_ERROR',
    INVALID_CHOICE: 'INVALID_CHOICE_ERROR',
    MIN_CHOICES: 'MIN_CHOICES_ERROR',
    MAX_CHOICES: 'MAX_CHOICES_ERROR',
    MIN_CHOICES_ROW: 'MIN_CHOICES_ROW_ERROR',
    MAX_CHOICES_ROW: 'MAX_CHOICES_ROW_ERROR',
    UPLOAD_SIZE: 'UPLOAD_SIZE_ERROR',
    UPLOAD_TYPE_IMAGE: 'UPLOAD_TYPE_IMAGE_ERROR',
    OCCURRENCIES: 'OCCURRENCIES_ERROR',
    MIN_OCCURRENCIES: 'MIN_OCCURRENCIES_ERROR',
    MAX_OCCURRENCIES: 'MAX_OCCURRENCIES_ERROR',
    COMPOSITION_ERROR: 'COMPOSITION_ERROR',
    MIN_CHOICES_ORDER: 'MIN_CHOICES_ORDER_ERROR',
    OVERALL_REQUIRED: 'OVERALL_REQUIRED_ERROR',
    OVERALL_MAX_NUMBER: 'OVERALL_MAX_NUMBER_ERROR',
    OVERALL_MIN_NUMBER: 'OVERALL_MIN_NUMBER_ERROR',
    OVERALL_COMPOSITION: 'OVERALL_COMPOSITION_ERROR',
};

exports.SERVER_ERRORS = {
    GENERIC: 'ERROR',
    NOT_FOUND: 'NOT_FOUND',
    PARSER: 'PARSER_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED',
    VALIDATION: 'VALIDATION_ERROR',
    INSTANCE_STATE: 'INSTANCE_STATE_ERROR',
    BAD_REQUEST: 'BAD_REQUEST',
};

exports.EDITOR_TEMPLATES = {
    // Variabile a risposta aperta
    STRING_1: 'string_1',
    // Variabile nominale
    SINGLE_CHOICE_1: 'single_choice_1',
    // Variabile ordinale
    SINGLE_CHOICE_2: 'single_choice_2',
    // Likert
    SINGLE_CHOICE_3: 'single_choice_3',
    // Image picker
    SINGLE_CHOICE_4: 'single_choice_4',
    // Scelta singola con dati esterni
    SINGLE_CHOICE_1_EXT: 'single_choice_1_ext',
    // Variabile cardinale
    NUMBER_1: 'number_1',
    // Scala ad intervalli
    NUMBER_2: 'number_2',
    // Differenziale semantico
    MULTIPLE_NUMBER_1: 'multiple_number_1',
    // Batteria numerica (scala ad intervalli "multipla")
    MULTIPLE_NUMBER_2: 'multiple_number_2',
    // Variabile composizione
    MULTIPLE_NUMBER_3: 'multiple_number_3',
    // Risposta multipla
    MULTIPLE_CHOICE_1: 'multiple_choice_1',
    // Risposta multipla immagini
    MULTIPLE_CHOICE_2: 'multiple_choice_2',
    // Risposta multipla immagini
    RANK_1: 'rank_1',
    // Data
    DATE_1: 'date_1',
    // Batteria scelta singola
    BATTERY_1: 'battery_1',
    // Batteria scelta multipla
    BATTERY_2: 'battery_2',
    // Upload immagine
    IMAGE_1: 'image_1',
    // Solo testo
    TEXT_1: 'text_1',
    // Mappa
    GEO_1: 'geo_1',
    // Riclassificatore (in ingresso numerica, in output single choice)
    GENERATOR_CLASSIFIER: 'generator_classifier',
    // Cartella (serve per mappare i raggruppamenti di categoria)
    FOLDER: 'folder',
    // Icona back (per tornare al livello superiore nella scelta categoria)
    BACK: 'back',
    // Riclassificatore (in output single choice)
    GENERATOR_CLASSIFIER_2: 'generator_classifier_2',
};

exports.EDITOR_LOGIC_OPERATORS = {
    AND: 'and',
    OR: 'or',
};

exports.EDITOR_OPERATORS = {
    EQ: '=',
    NEQ: '!=',
    GT: '>',
    LT: '<',
    GTE: '>=',
    LTE: '<=',
    CONTAINS: 'contains',
    IN: 'in',
    NOT_IN: '!in',
};

exports.STEP_DECIMALS = 2;

exports.SENTIMENT_ANALYSIS_SENTIMENTS = ['POSITIVE', 'MIXED', 'NEGATIVE', 'NEUTRAL'];

exports.WIDGET_TYPES = {
    GENERATOR_SENTIMENT_ANALYSIS: exports.CONTENT_TYPES.GENERATOR_SENTIMENT_ANALYSIS,
    GENERATOR_ENTITY_EXTRACTION: exports.CONTENT_TYPES.GENERATOR_ENTITY_EXTRACTION,
    GENERATOR_NPS: exports.CONTENT_TYPES.GENERATOR_NPS,
    GEO: exports.CONTENT_TYPES.GEO,
    MULTIPLE_CHOICE: exports.CONTENT_TYPES.MULTIPLE_CHOICE,
    NUMBER: exports.CONTENT_TYPES.NUMBER,
    SINGLE_CHOICE: exports.CONTENT_TYPES.SINGLE_CHOICE,
    SINGLE_CHOICE_BATTERY: exports.CONTENT_TYPES.SINGLE_CHOICE_BATTERY,
    MULTIPLE_CHOICE_BATTERY: exports.CONTENT_TYPES.MULTIPLE_CHOICE_BATTERY,
    MULTIPLE_NUMBER3_BATTERY: exports.CONTENT_TYPES.MULTIPLE_NUMBER3_BATTERY,
    RANK: exports.CONTENT_TYPES.RANK,
    INSTANCE_COMPLETED_AT: 'instanceCompletedAt',
    SURVEY_STATS: 'surveyStats',
    SURVEY_SENT_STATS: 'surveySentStats',
    CHANNEL_STATS: 'channelStats',
};

const USER_ROLES = {
    ADMIN: 'ADMIN',
    ORGANIZATION_ADMIN: 'ORGANIZATION_ADMIN',
    READER: 'READER',
    GUEST: 'GUEST',
};
exports.USER_ROLES = USER_ROLES;

const PERMISSIONS = {
    ADMIN: 'ADMIN',
    BRANDING: 'BRANDING',
    DASHBOARD_VIEW: 'DASHBOARD_VIEW',
    INSTANCES_EXPORT: 'INSTANCES_EXPORT',
    TRACKERS: 'TRACKERS',
    SURVEY_EDIT: 'SURVEY_EDIT',
    SURVEY_SHARE: 'SURVEY_SHARE',
};
exports.PERMISSIONS = PERMISSIONS;

exports.ROLES_TO_PERMISSIONS = {};
exports.ROLES_TO_PERMISSIONS[USER_ROLES.GUEST] = [
    PERMISSIONS.DASHBOARD_VIEW];
exports.ROLES_TO_PERMISSIONS[USER_ROLES.READER] = [...exports.ROLES_TO_PERMISSIONS[USER_ROLES.GUEST],
    PERMISSIONS.INSTANCES_EXPORT, PERMISSIONS.TRACKERS, PERMISSIONS.SURVEY_SHARE];
exports.ROLES_TO_PERMISSIONS[USER_ROLES.ORGANIZATION_ADMIN] = [...exports.ROLES_TO_PERMISSIONS[USER_ROLES.READER],
    PERMISSIONS.BRANDING, PERMISSIONS.SURVEY_EDIT];
exports.ROLES_TO_PERMISSIONS[USER_ROLES.ADMIN] = [...exports.ROLES_TO_PERMISSIONS[USER_ROLES.ORGANIZATION_ADMIN],
    PERMISSIONS.ADMIN];

exports.BRANDING_FONTS = {
    WORK_SANS: 'WORK_SANS',
    ROBOTO: 'ROBOTO',
    OSWALD: 'OSWALD',
    LORA: 'LORA',
    LOBSTER_TWO: 'LOBSTER_TWO',
    KALAM: 'KALAM',
    ALBERT: 'ALBERT',
};

exports.CHATBOT_PREFIX_CODE = 'NSV';

exports.UPLOAD_MAX_SIZE = 11200000; // ~10.7MB (=8MB base64)
exports.UPLOAD_MAX_SIZE_HUMAN = Math.floor(exports.UPLOAD_MAX_SIZE * 3 / 4 / (1024 * 1024)) + 'MB';

exports.TRACKER_MESSAGE_TYPES = {
    INVITATION: 'invitation',
    REMINDER: 'reminder',
};

// eslint-disable-next-line max-len
exports.GSM_7BIT_ALPHABET_REGEX = /^[A-Za-z0-9 \r\n@£$¥èéùìòÇØøÅå\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039EÆæßÉ!"#$%&'()*+,\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}[~\]|\u20AC]*$/;

exports.NPS_CATEGORIES = {
    DETRACTOR: 'DETRACTOR',
    PASSIVE: 'PASSIVE',
    PROMOTER: 'PROMOTER',
};

exports.EMAIL_TEMPLATE_TYPE = {
    DEFAULT: 'default',
    FILE: 'file',
};

exports.INSTANCE_PROCESSOR_TYPES = {
    EXTERNAL_PROVIDER: 'externalProvider',
    SHUFFLE: 'shuffle',
    SHUFFLE_PAGE: 'shufflePage',
    SHUFFLE_REINDEX_PREVIOUS: 'shuffleReindexPrevious',
    EXCLUSIVE: 'exclusive',
    OCCURRENCIES: 'occurrencies',
    DETAIL: 'detail',
};

exports.getEmailTemplateType = (type) => Object.values(exports.EMAIL_TEMPLATE_TYPE).includes(type) ? type : exports.EMAIL_TEMPLATE_TYPE.DEFAULT;
